import type { Order } from "@/types/supabase";
import { calculateOrderTotal, formatCurrency } from "@/lib/formatCurrency";

interface OrderTotalProps {
  order: Order;
}

export function OrderTotal({ order }: OrderTotalProps) {
  const total = calculateOrderTotal(order);

  return (
    <span className="text-sm text-gray-600">
      {formatCurrency(total, order.currency)}
    </span>
  );
}
